import type { DiagnosticProduct } from "sdk/diagnosticUserProducts";

export type IntakeAnswerType =
  | "text"
  | "options"
  | "media"
  | "text_media"
  | "text_options";

export interface IntakeAnswer {
  fh_id: string;
  value: any;
  stepId: string;
  type: IntakeAnswerType;
  acceptsLabTestMedia?: boolean; // Signal to server that this field should receive lab test media IDs
}

export interface IntakeFormAnswers {
  [questionSlug: string]: IntakeAnswer;
}

export interface Consultation {
  id: number;
  external_id: string;
  acuity_appointment_id: string;
  acuity_appointment_type_id?: string;
  acuity_calendar_id?: string;
  consultation_type: string;
  provider_name: string;
  status?:
  | "scheduled"
  | "canceled"
  | "completed"
  | "assigned"
  | "rejected"
  | "denied"
  | "no_show"
  | "pending";
  scheduled_datetime?: string;
  duration?: number;
  no_show?: boolean;
  canceled_at?: string;
  source?: string;
  diagnostic_user_id: number;
  diagnostic_user_product_id: number;
  lab_test_id?: number;
  created_at: string;
  updated_at: string;
  external_url?: string;
  reason?: string;
  fh_prescription_request_id?: string;
  diagnostic_product?: DiagnosticProduct;
}

export interface CreateConsultationRequest {
  diagnostic_user_product_id: string;
  intake_answers: IntakeFormAnswers;
  lab_test_id?: number;
}

export type CreateConsultationResponse = Consultation;

export const consultationsCreateQuery = (params: CreateConsultationRequest) => {
  const { diagnostic_user_product_id, ...bodyParams } = params;
  return {
    url: `/api/v1/diagnostics/diagnostic_user_products/${diagnostic_user_product_id}/consultations`,
    method: "POST" as const,
    body: bodyParams,
  };
};
